export const roleKeys = {
  DRAFTER: 'drafter',
  REVIEWER: 'reviewer'
};

export const ROLES = [roleKeys.DRAFTER, roleKeys.REVIEWER];
